import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'calendar.header.title',
		description: 'Title of the Jira calendar view page',
		defaultMessage: 'Calendar',
	},
});
